import React from 'react';
import { Check, Power } from 'lucide-react';

interface DeviceMediaProps {
  /** Which indicator overlay to magnify on the device. */
  indicator?: 'step1' | 'success' | 'none';
  /** Show the green success check badge (Step 6). */
  showCheck?: boolean;
  /** Caption shown under the device (e.g. "Indicator light-is ON"). */
  caption?: string;
}

/**
 * The SmartEco device illustration with the magnified indicator-light circle,
 * shown in the left column of every web onboarding step.
 */
const DeviceMedia: React.FC<DeviceMediaProps> = ({
  indicator = 'step1',
  showCheck = false,
  caption,
}) => {
  const base = `${process.env.PUBLIC_URL}/DeviceSetup`;
  const indicatorName =
    indicator === 'success' ? 'all-success-indicator' : 'step1-indicator';

  return (
    <div className="dcfw-image-source">
      <div className="dcfw-device-wrap">
        <picture>
          <source srcSet={`${base}/device-mobile.avif`} type="image/avif" />
          <img
            srcSet={`${base}/device-mobile.webp`}
            alt="SmartEco IAQ device"
            className="dcf-illustration"
          />
        </picture>

        {indicator !== 'none' && (
          <picture className="dcfw-indicator">
            <source srcSet={`${base}/${indicatorName}.avif`} type="image/avif" />
            <img
              src={`${base}/${indicatorName}.webp`}
              alt="Device indicator light"
              className="dcfw-indicator-image"
            />
          </picture>
        )}

        {showCheck && (
          <div className="dcf-status-icon dcfw-check-badge" aria-hidden="true">
            <Check strokeWidth={2} />
          </div>
        )}
      </div>

      {caption && (
        <div className="dcfw-image-caption">
          <Power size={14} />
          <span>{caption}</span>
        </div>
      )}
    </div>
  );
};

export default DeviceMedia;
